export default __webpack_public_path__ + "static/media/13.afff6132.svg";